import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getRoleAPI = (selectedStatus:any,sortField:any,sortDirection:any) => {
  return Http.get(`role?status=${selectedStatus}&sort_by=${sortField}&sort_direction=${sortDirection}`);
};
export const addRoleAPI = (data:any) => {
  return Http.post(ApiRoutes.addRole,data);
};
export const getRoleIdAPI = (id:any) => {
  return Http.get(`role/${id}`);
};
export const editRoleAPI = (id:any,data:any) => {
  return Http.put(`role/${id}`,data);
};
export const deleteRoleAPI = (id:any) => {
  return Http.delete(`role/${id}`);
};

// Get roles by active status :
export const getRoleByStatus = (data: any) => {
  return Http.get(ApiRoutes.getRole, { status: data });
};